import PropTypes from 'prop-types';
import React from 'react';

import ListItem from './ListItem';
import ItemCheckBox from './ItemCheckBox';
import Item from './Item';

class RadioListItem extends React.PureComponent {
  state = { hover: false }

  handleClick = () => {
    this.props.onClick(this.props.id);
  }

  handleMouseEnter = () => {
    this.setState({ hover: true });
  }

  handleMouseLeave = () => {
    this.setState({ hover: false });
  }

  render() {
    return (
      <ListItem
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <ItemCheckBox hover={this.props.selected || this.state.hover} />

        {/* TODO: убрать наследование */}
        <Item hover={this.props.selected || this.state.hover}>
          {this.props.item.title || this.props.item.content || `id: '${this.props.item.id}'`}
        </Item>
      </ListItem>
    );
  }
}

RadioListItem.propTypes = {
  id: PropTypes.string.isRequired,
  item: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
  }).isRequired,

  selected: PropTypes.bool,

  onClick: PropTypes.func,
};

RadioListItem.defaultProps = {
  selected: false,

  onClick: () => {},
};

export default RadioListItem;
